import Gateway from '../../utils/global/Gateway'

export default
{
    name: 'app-newsletter',

    props:
    {

    },

    data()
    {
        return {
            email: '',
            message: 'Oups, something went wrong!',
            type: 'success',
            active: false,
            loading: false
        }
    },

    created()
    {
        this.eventHub.$on('application:keydown', this._onKeydown)
    },

    destroyed()
    {
        this.eventHub.$off('application:keydown', this._onKeydown)
    },

    methods:
    {
        // EVENTS
        _onKeydown(event)
        {
            if (event.keyCode === 13) this._sendForm()

            this.active = false
        },

        // HTML ACTIONS
        _sendForm()
        {
            const url = `${this.$root.CONFIG.env.path}/newsletter.php`
            this.loading = true

            return new Promise((resolve, reject) =>
            {
                Gateway.getInstance().send(
                    'POST',
                    url,
                    {
                        email: this.email
                    },
                    response =>
                    {
                        resolve(response)
                    },
                    error =>
                    {
                        reject(error)
                    }
                )
            })
            .then(response =>
            {
                if (response.error_status === 0)
                {
                    this.loading = false
                    this.active = true
                    this.message = 'Email saved!'
                    this.type = 'success'
                }
                else
                {
                    this.loading = false
                    this.active = true
                    this.message = 'Oups, something went wrong!'
                    this.type = 'error'
                }
            })
            .catch(() =>
            {
                this.loading = false
                this.active = true
                this.message = 'Oups, something went wrong!'
                this.type = 'error'
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-newsletter/script.js